import getOr from "lodash/fp/getOr";

const selectUIVersion = getOr(1, ["app", "formData", "UIVersion"]);

export default selectUIVersion;
